export default {
  icon () {
    const self = this
    if (self.icon instanceof File) {
      const reader = new FileReader()

      reader.readAsDataURL(self.icon)

      reader.onload = function () {
        self.modality.icon = reader.result
      }
    }
  },
}
